import Bout from "../../bout/Bout.js";
import Player from "../../bout/Player.js";
import Game from "../../Game.js";
import ItemProviders from "../../items/ItemProviders.js";
import Helper from "../../utils/helper/Helper.js";
import EnemySlot from "../fight/EnemySlot.js";
import Skills from "../skills/Skills.js";

export default class MobInfo {
	constructor(mob, stack) {
		this.mc = null;
		this.mob = mob;
		this.stack = stack;
		this.player = Bout.that.player;
		this.mc = jQuery("#template-mobinfo").clone();
		this.mc.attr("id", "mobinf" + MobInfo.ENUM++);

	}

	init() {
		this.build();
	}


	getClip() {
		return this.mc;

	}

	build() {
		if (MobInfo.checkTactics.indexOf(this.mob.id) < 0) {
			MobInfo.checkTactics.push(this.mob.id);
			Player.checkSkill(Skills.SKILL_TACTICS);
		}

		let a = this.stack;
		for (let x = 0; x < a.length; x++) {
			let line = jQuery("#template-singlemobinfo").clone();
			line.attr("id", "simoin" + MobInfo.ENUM++);
			jQuery(".js-image", line).css("background-image", "url('" + "./assets/ui/slot-mob.png" + "')");
			this.mc.append(line);
			let mob = a[x];
			//let img = new Image();
			//img.src = sprite;
			let tact = Bout.that.player.getSkillValue(Skills.SKILL_TACTICS);

			jQuery(".js-mob-image", line).css("background-image", "url('" + this.getImage(mob, tact, x) + "')");

			//jQuery(".js-mob-image", line).css("background-image", "url('')");
			let cls = this.getColored(mob, tact);
			jQuery(".js-name", line).text(this.getName(mob, tact));
			jQuery(".js-name", line).addClass(cls)
			jQuery(".js-infos", line).addClass(cls)
			jQuery(".js-level", line).text("" + this.getLevel(mob, tact));
			jQuery(".js-hp", line).text("" + this.getHp(mob, tact))
			jQuery(".js-damage", line).text("" + this.getDamage(mob, tact))
			jQuery(".js-armour", line).text("" + this.getArmour(mob, tact))
			jQuery(".js-speed", line).text("" + this.getSpeed(mob, tact))

			if (this.getStars(mob, tact)) {
				for (let x = 0; x < mob.lore.stars; x++) {
					let star = jQuery("#template-little-star").clone();
					star.removeAttr("id");
					jQuery(".js-stars", line).append(star);
				}
			}

		}
	}

	getHeight() {
		return this.mc.height();
	}


	getColored(mob, tact) {
		let cls = EnemySlot.compareLevels(mob);
		return cls;
	}

	getName(mob, tact) {
		if (mob.lore.named) {
			if (tact < MobInfo.MIN_TACT_FOR_NAMED) {
				return "???"
			}
		}
		return "" + mob.lore.name
	}
	getLevel(mob, tact) {
		if (tact < MobInfo.MIN_TACT_FOR_LEVEL) {
			return "?"
		}
		return "" + mob.lore.level
	}

	getHp(mob, tact) {
		if (tact < MobInfo.MIN_TACT_FOR_HP) {
			return "?"
		}
		return "" + mob.lore.hp
	}

	getDamage(mob, tact) {
		if (tact < MobInfo.MIN_TACT_FOR_DAMAGE) {
			return "?"
		}
		return "" + mob.lore.min_damage + "-" + mob.lore.max_damage
	}

	getArmour(mob, tact) {
		if (tact < MobInfo.MIN_TACT_FOR_ARMOUR) {
			return "?"
		}

		return "" + mob.lore.armour
	}

	getSpeed(mob, tact) {
		if (tact < MobInfo.MIN_TACT_FOR_SPEED) {
			return "?"
		}
		return "" + mob.lore.speed
	}

	getImage(mob, tact, n) {
		let sprite;
		if (n === 0) {
			sprite = mob.sp.getSprite(mob.race, 0, 0);
		} else {
			if (tact < MobInfo.MIN_TACT_FOR_IMAGE) {
				sprite = "./assets/ui/icon_unknown.png";
			} else {
				sprite = mob.sp.getSprite(mob.race, 0, 0);
			}
		}
		return sprite
	}


	getStars(mob, tact) {
		if (tact < MobInfo.MIN_TACT_FOR_STARS) {
			return false;
		}
		return true;
	}
}

MobInfo.ENUM = 0;
MobInfo.checkTactics = new Array();

MobInfo.MIN_TACT_FOR_IMAGE = 100;
MobInfo.MIN_TACT_FOR_STARS = 150;
MobInfo.MIN_TACT_FOR_LEVEL = 200;
MobInfo.MIN_TACT_FOR_NAMED = 350;
MobInfo.MIN_TACT_FOR_HP = 500;
MobInfo.MIN_TACT_FOR_DAMAGE = 650;
MobInfo.MIN_TACT_FOR_ARMOUR = 800;
MobInfo.MIN_TACT_FOR_SPEED = 950;